import React, { Component } from 'react';
import { Button } from 'react-responsive-ui'
import PropTypes from 'prop-types';
import { getGuardians, getProtegees } from '../helpers/registrationHelper';
import GuardianModal from '../components/guardianModal';
import Success from './success';

class Guardians extends Component {

    constructor(props) {
        super(props);
        this.state = props;
        this.saveGuardian = this.saveGuardian.bind(this);
        this.saveSuccessMsg = this.saveSuccessMsg.bind(this);
    }

    componentDidMount() {
        getGuardians()
            .then((data) => {
                this.setState({ guardians: data.data.guardians })
            }).catch((error) => {
                console.log(error)
            })
        getProtegees()
            .then((data) => {
                this.setState({ protegees: data.data.protegees })
            }).catch((error) => {
                console.log(error)
            })
    }

    render() {
        if (this.state && this.state.moduleType === 'BANNER') {
            return (
                <div>
                    <div className="page-container">
                        <div className="welcome-text">
                            <h2>Welcome Kimberley!</h2>
                            <p>
                                Tor renestrupta voluptiam ipsam et fuga. Lum idus aut odipsae a prae rem que
                    voloria cus eum quisquas aut officiis aut que recuptas rerciae.
            </p>
                        </div>
                    </div>
                    <div>
                        {this.getBannerGuardians()}
                    </div>
                </div>
            )
        } else if (this.state && this.state.moduleType === 'BLOCK') {
            return (
                <div>
                    {this.getBlockGuardians()}
                    {this.getBlockProtegees()}
                </div>
            )
        } else if (this.state && this.state.moduleType === 'PAGE') {
            return (
                this.getPageGuardians()
            )
        } else if (this.state && this.state.moduleType === 'MESSENGER_LIST') {
            return (
                this.getMessengerList()
            )
        } else {
            return (
                <div>No Guardians</div>
            )
        }
    }

    getMessengerList() {
        var relations;
        if (this.state.guardians && this.state.protegees) {
            relations = this.state.guardians.concat(this.state.protegees);
        } else {
            relations = [];
        }
        return (
            <div className="guardian-messenger-wrapper">
            <h3>Add one of your guardians</h3>
                <div className="guardian-messenger-list">
                    {relations && relations.map((item, key) => (
                    <Button action={() => {this.props.createChannel(item)}} key={key}>
                        {item.name}
                    </Button>
                    ))}
                </div>
            </div>
        )

    }

    getBannerGuardians() {
        var relations;
        if (this.state.guardians && this.state.protegees) {
            relations = this.state.guardians.concat(this.state.protegees);
        } else {
            relations = [];
        }
        return (
            <div className="guardians-banner">
                <div className="guardians-top">
                    <div className="page-container">
                        Followers and Following
                    </div>
                </div>
                <div className="page-container">
                    <div className="guardians-list">
                        {/* {this.state.guardians && this.state.guardians.map((item, key) => ( */}
                        {relations && relations.slice(0, 6).map((item, key) => (
                            <a onClick={() => { this.redirectToProfile(item) }} key={key}>
                                <div className="guardian">
                                    <div className="guardian-circle">
                                        {item.name && item.name[0].toUpperCase()}
                                    </div>
                                    <div className="guardian-name">
                                        {item.name}
                                    </div>
                                </div>
                            </a>
                        ))}
                        {this.state.successMsg && <Success successMsg={this.state.successMsg} />}
                        {this.state.guardians && relations.length < 6 && <GuardianModal {...this.state.guardians} saveGuardian={this.saveGuardian} isNewGuardian={true} saveSuccessMsg={this.saveSuccessMsg} />}
                        {localStorage.getItem('name') &&
                            <div className="my-profile">
                                <div className="my-profile-circle">
                                    {localStorage.getItem('name') && localStorage.getItem('name')[0].toUpperCase()}
                                </div>
                                {localStorage.getItem('name')}

                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }


    saveGuardian(guardian) {
        if (this.state && this.state.guardians) {
            this.state.guardians.unshift(guardian)
            this.setState({ guardians: this.state.guardians })
        }
    }

    saveSuccessMsg(message) {
        if (this.state) {
            let array = this.state.successMsg ? this.state.successMsg : []
            array.unshift({ message: message, index: array.length - 1 });
            this.setState({ successMsg: array })
        }
    }


    getBlockGuardians() {
        return (
            <div className="guardians-block">
                Guardians
                {this.state.successMsg && <Success successMsg={this.state.successMsg} />}
                <div className="guardians-list">
                    {this.state.guardians && this.state.guardians.slice(0, 3).map((item, key) => (
                        <div className="guardian" key={key}>
                            <div className="guardian-circle">
                                {item.name[0].toUpperCase()}
                            </div>
                            <div className="guardian-name">
                                {item.name}
                            </div>
                        </div>
                    ))}

                    <GuardianModal isNewGuardian={true} saveGuardian={this.saveGuardian} saveSuccessMsg={this.saveSuccessMsg} />
                </div>
            </div>
        )
    }

    getPageGuardians = () => {
        return (
            <div>
                {this.state.successMsg &&
                    <Success successMsg={this.state.successMsg} />
                }
                <div className="guardians-list">
                    {this.state.guardians && this.state.guardians.map((item, key) => (
                        <div className="guardian" key={key}>
                            <div className="guardian-circle">
                                {item.name[0].toUpperCase()}
                            </div>
                            <div>
                                {item.name}
                            </div>
                            <GuardianModal isNewGuardian={false} saveGuardian={this.saveGuardian} guardian={item} saveSuccessMsg={this.saveSuccessMsg} />
                        </div>
                    ))}
                </div>
                {this.getAddGuardianModule()}
            </div>
        )
    }

     getProtegeesBlock = () => {
        return (
            <div className="guardians-block">
                Protegees                    {this.state.successMsg && <Success successMsg={this.state.successMsg} />}
                <div className="guardians-list">
                    {this.state.protegees && this.state.protegees.slice(0, 4).map((item, key) => (
                        <div className="guardian" key={key}>
                            <div className="guardian-circle">
                                {item.name[0].toUpperCase()}
                            </div>
                            <div className="guardian-name">
                                {item.name}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    getAddGuardianModule = () => {
        return (
            <div className="add-guardian-container">
                <h2>Add guardians</h2>
                {this.state.guardiansToAdd && this.state.guardiansToAdd.map((item, key) => {
                    <p key={key}>{item.name}</p>
                })}
            </div>
        )
    }

    redirectToProfile = (item) => {
        this.props.history.push({
            pathname: '/friendProfile',
            state: { user: item }
        })
    }

}

Guardians.propTypes = {
    history: PropTypes.object,
    createChannel: PropTypes.func
};
export default Guardians;


// WEBPACK FOOTER //
// ./src/components/guardians.js